// removed by extract-text-webpack-plugin
module.exports = {"timelineChart":"antd-pro-timelineChart"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/TimelineChart/index.less
// module id = 368
// module chunks = 0 1